import { render, staticRenderFns } from "./Giveaway.vue?vue&type=template&id=5f4ba29f&scoped=true&"
import script from "./Giveaway.vue?vue&type=script&lang=js&"
export * from "./Giveaway.vue?vue&type=script&lang=js&"
import style0 from "./Giveaway.vue?vue&type=style&index=0&id=5f4ba29f&prod&lang=scss&scoped=true&"
import style1 from "./Giveaway.vue?vue&type=style&index=1&id=5f4ba29f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4ba29f",
  null
  
)

export default component.exports